import { Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { LocalHospitalOutlined, SearchOutlined, ManageAccountsOutlined, PersonalInjuryOutlined, DatasetOutlined } from '@mui/icons-material';
import { IconTextButton } from 'Components/Button';
import { ICONS } from 'Utils/icons';
import { PATHS } from 'Utils/PagePaths';

export const NotFound = () => {

    const navigate = useNavigate();

    return (
        <>
            <Row className="d-flex justify-content-center w-100 m-0 p-0 g-0 mt-5">
                <Col className="pb-2 page-not-found-header" xs={11} sm={9} md={11} lg={9} xl="8">
                    <h1 id="mainContent" className='text-start title mb-3'>We can't find the page you're looking for.</h1>
                    <p className='text-start mb-3'>We are unable to locate the page you requested on <span className="info">psoppc.org</span>. This may be because the web address is incorrect or the page has been moved.</p>
                    <p className='text-start info'>The following options may help you find what you need:</p>
                </Col>
            </Row>
            <Col className="pb-2  mb-0 ms-auto me-auto d-flex " xs={11} sm={9} md={11} lg={10} xl="10" >
                <Row lg={2} className="cta-cards col-gap-2 row-gap-3 mt-3 pb-5 justify-content-center">
                    <Col className="" lg={10}>
                        <Card className="h-100 border-0">
                            <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4">
                                <div className="align-items-center">
                                    <SearchOutlined fontSize="large"></SearchOutlined>
                                </div>
                                <div className="">
                                    <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold">Search our Documents</span></div>
                                    <div className="public-card-content d-flex flex-column align-items-start">
                                        <p className="text-start body regular color-32363E">Use our site-wide search tool to find specific documentation or resources.</p>
                                        <IconTextButton
                                            variant="clear"
                                            icon={ICONS.arrow}
                                            className="reverse p-0 "
                                            content="Go to search page"
                                            onClick={() =>
                                                navigate(PATHS.public['Search'])
                                            }
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col className="" lg={10}>
                        <Card className="h-100 border-0">
                            <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4">
                                <div className="align-items-center">
                                    <ManageAccountsOutlined fontSize="large"></ManageAccountsOutlined>
                                </div>
                                <div className="">
                                    <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold">Become a PSO</span></div>
                                    <div className="public-card-content d-flex flex-column align-items-start">
                                        <p className="text-start body regular color-32363E">If your organization's primary mission and work focuses on improving patient safety and the quality of healthcare delivery, you may be eligible to become a PSO.</p>
                                        <IconTextButton
                                            variant="clear"
                                            icon={ICONS.arrow}
                                            className="reverse p-0 "
                                            content="Learn More"
                                            onClick={() =>
                                                navigate(PATHS.public['Become a PSO'])
                                            }
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col className="" lg={10}>
                        <Card className="h-100 border-0">
                            <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4">
                                <div className="align-items-center">
                                    <LocalHospitalOutlined fontSize="large"></LocalHospitalOutlined>
                                </div>
                                <div>
                                    <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold ">Use Common Formats</span></div>
                                    <div className="public-card-content  d-flex flex-column align-items-start">
                                        <p className="text-start body regular color-32363E">If you are looking for a standardized structure for patient safety event data, you might be looking for our Common Formats.</p>
                                        <IconTextButton
                                            variant="clear"
                                            icon={ICONS.arrow}
                                            className="reverse p-0 "
                                            content="Learn More"
                                            onClick={() =>
                                                navigate(PATHS.public['Use Common Formats'])
                                            }
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col className="" lg={10}>
                        <Card className="h-100 border-0">
                            <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4">
                                <div className="align-items-center">
                                    <PersonalInjuryOutlined fontSize="large"></PersonalInjuryOutlined>
                                </div>
                                <div>
                                    <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold ">Submit Data</span></div>
                                    <div className="public-card-content d-flex flex-column align-items-start">
                                        <p className="text-start body regular color-32363E">By securely sharing your PSO's patient safety data with PSOPPC, you contribute to national learning that helps improve the quality of care.</p>
                                        <IconTextButton
                                            variant="clear"
                                            icon={ICONS.arrow}
                                            className="reverse p-0 "
                                            content="Learn More"
                                            onClick={() =>
                                                navigate(PATHS.public['Submit Data'])
                                            }
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col className="" lg={10}>
                        <Card className="h-100 border-0">
                            <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4">
                                <div className="align-items-center">
                                    <DatasetOutlined fontSize="large"></DatasetOutlined>
                                </div>
                                <div>
                                    <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold ">Learn from the Data</span></div>
                                    <div className="public-card-content d-flex flex-column align-items-start">
                                        <p className="text-start body regular color-32363E">The Network of Patient Safety Databases (NPSD) team at AHRQ transforms your submitted, non-identifiable patient safety data into useful tools like dashboards and reports with clear, actionable information.</p>
                                        <IconTextButton
                                            variant="clear"
                                            icon={ICONS.arrow}
                                            className="reverse p-0 "
                                            content="Learn More"
                                            onClick={() =>
                                                navigate(PATHS.public['Learn from the Data'])
                                            }
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </>
    );
}